export const AUDIO_CACHE='webreader-audio-v5';

// Keep only the previous/current clips and the next two. Never fetch a whole book.
export async function prefetchAudio(urls,keep,signal){
  if(!('caches'in window)||!navigator.serviceWorker?.controller||navigator.connection?.saveData||/2g/.test(navigator.connection?.effectiveType||''))return;
  const cache=await caches.open(AUDIO_CACHE),allowed=new Set(keep);
  for(const request of await cache.keys())if(!allowed.has(request.url))await cache.delete(request);
  for(const url of urls){
    if(signal.aborted)return;
    if(await cache.match(url))continue;
    const response=await fetch(url,{signal,priority:'low'});
    if(response.ok&&!signal.aborted)await cache.put(url,response);
  }
}
